import axios from 'axios'
import { UserSchema } from '../models/user'
import { useQuery } from '@tanstack/react-query'

const getUserInfo = async () => {
  try {
    const res = await axios.get('/api/admin/me')
    return UserSchema.parse(res.data)
  } catch (error) {
    throw new Error('Failed to get user info.')
  }
}

export const useUserInfo = () => {
  return useQuery({
    queryKey: ['user'],
    queryFn: () => getUserInfo(),
  })
}
